var map = {
	"./common/en.json": "78fo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z5zU";


//////////////////
// WEBPACK FOOTER
// ./src/lang ^\.\/.*\/en\.json$
// module id = Z5zU
// module chunks = 65